import React from "react"
import { Link } from "react-router-dom"

import { LOCALE } from "consts/locale"
import consts from "consts"
import formatterHelper from "helpers/formatter"

import styles from "./pageProgram.css"

export const getBottomtext = (programId, channelUrl) => {
  // Plus belle la vie
  if (programId === consts.programs.pblvMainProgram.id) {
    return (
      <>
        <h2 className={styles.bottomTextTitle}>Plus belle la vie (PBLV) le feuilleton marseillais préféré des français</h2>

        <div className={styles.bottomTextSection}>
          <p>
            Avec plus de quatre mille épisodes, la série Plus Belle La Vie (ou "pblv" pour les connaisseurs) est devenue un véritable phénomène de
            société. Lancée en 2004, Plus Belle la Vie est diffusée <Link to={channelUrl}>en direct sur France 3</Link> du lundi au vendredi et plonge
            les spectateurs dans le quotidien des habitants du Mistral, un quartier imaginaire à Marseille. Depuis, Roland, Mirta, Blanche ou encore
            Vincent et Céline sont véritablement entrés dans le quotidien des français, mais pas seulement. En effet, le succès de Plus Belle la Vie
            ne se limite pas aux frontières de la France. La série originale de France 3 est également diffusée en Belgique, en Suisse, en Finlande et
            bien d’autres pays européens.
          </p>
        </div>
        <div className={styles.bottomTextSection}>
          <p>
            La raison d’un tel succès ? Une recette bien huilée ! Histoires sentimentales, phénomènes paranormaux et événements du quotidien se mêlent
            dans chaque épisode de Plus Belle la Vie et ce, pour le plus grand bonheur du public. Épisode après épisode, les téléspectateurs sont
            ainsi de plus en plus nombreux à suivre les aventures des habitants du Mistral, leurs familles, leurs amis et parfois, leurs ennemis. Ces
            derniers sont à l’origine d’intrigues policières sous-jacentes qui promettent aux téléspectateurs leur lot de frissons supplémentaires.
          </p>
        </div>
        <div className={styles.bottomTextSection}>
          <p>
            Diffusée du lundi au vendredi à 20h10 sur France 3, Plus Belle la Vie est disponible en replay. Vous avez raté un épisode ou vous
            souhaitez tout simplement revoir un de vos épisodes préférés ? Tous les épisodes de Plus Belle la Vie vous attendent en streaming sur
            l’application Molotov.tv. Vous ne voulez pas attendre ? Des résumés des épisodes à venir sont à votre disposition sur le site officiel de
            Plus Belle la Vie. Enfin, vous en voulez toujours plus ? De nombreux extraits des épisodes à venir, aussi appelés « indiscrétions », sont
            mis en ligne pour les plus curieux d’entre nous. Mais attention aux spoilers ! Vous ne pourrez pas dire que l’on ne vous a pas prévenu.
          </p>
        </div>
      </>
    )
  }

  // Un si grand soleil
  if (programId === consts.programs.unSiGrandSoleilProgram) {
    return (
      <>
        <h2 className={styles.bottomTextTitle}>Un si grand soleil le feuilleton montpelliérain préféré des français</h2>

        <div className={styles.bottomTextSection}>
          <p>
            Un si grand soleil est un feuilleton de début de soirée diffusé du lundi au vendredi <Link to={channelUrl}>en direct sur France Ô</Link>.
            D’une durée de vingt-deux minutes, chaque épisode débute à 20h40 pour accompagner le téléspectateur vers le prime time qui suit. Le
            scénario est un savant mélange d’histoires sentimentales et d’intrigues policières le tout dans un décor méditerranéen chaleureux. Lancé
            en 2018, Un si grand soleil rencontre un succès immédiat et enregistre depuis des audiences record.
          </p>
        </div>
        <div className={styles.bottomTextSection}>
          <p>
            Côté scénario, une équipe de 25 scénaristes alimente les rebondissements d’Un si grand soleil avec un seul mot d’ordre : authenticité.
            Côté distribution, l’actrice Mélanie Maudran, que l’on connaît pour son rôle dans la mythique série Sous le soleil, incarne Claire, 34
            ans. Personnage central de l’intrigue dès les premiers épisodes d’Un si grand soleil, Claire revient s’installer à Montpellier avec son
            fils Théo (Gary Guénaire) après des années d’absence. Dès le premier épisode, elle se retrouve soupçonnée d’un crime dont elle va devoir
            se disculper en replongeant dans son passé. Alors qu’elle lutte pour prouver son innocence, Claire est rapidement prise dans un triangle
            amoureux. Entre Manu, joué par l’acteur Moïse Santamaria, et Julien interprété par l’acteur Jeremy Banster, son cœur balance.
          </p>
        </div>
        <div className={styles.bottomTextSection}>
          <p>
            Un si grand soleil ne se contente pas de suivre les aventures de Claire. Le casting s’étend en effet à une quarantaine de personnages, des
            familles venues d’horizons divers et issues de milieux différents. Leurs destins vont s’entrecroiser au grès d’intrigues dramatiques et
            amoureuses pour le plus grand plaisir du public.
          </p>
        </div>
        <div className={styles.bottomTextSection}>
          <p>
            Alors que la moitié des scènes d’Un si grand soleil sont tournées dans les rues de Montpellier et alentours, le reste est tourné en
            studio. Pour les besoins du tournage, France TV construit ainsi des studios d’une superficie de 16 000 mètres carrés à Vendargues, dans la
            banlieue de Montpellier.
          </p>
        </div>
        <div className={styles.bottomTextSection}>
          <p>
            Diffusé du lundi au vendredi à 20h40 sur France 2, Un si grand soleil est également disponible en replay. Vous avez raté un épisode ou
            vous souhaitez tout simplement revoir un de vos épisodes préférés ? Tous les épisodes d’Un si grand soleil vous attendent en streaming sur
            l’application Molotov.tv. Vous ne voulez pas attendre ? Des résumés des épisodes à venir sont à votre disposition sur le site officiel de
            France 2. Enfin, vous en voulez toujours plus ? De nombreux extraits des épisodes à venir, aussi appelés « indiscrétions », sont mis en
            ligne pour les plus curieux d’entre nous.
          </p>
        </div>
      </>
    )
  }
  return false
}

export const getSeoText = programId => {
  if (programId === consts.programs.touchePasAMonPoste) {
    return (
      <div className={styles.seoContainer}>
        <h2 className={styles.seoTitle}>Touche Pas &agrave; Mon Poste en Streaming : Retrouvez TPMP en Direct sur Molotov TV</h2>
        <p className={styles.seoText}>
          Depuis plusieurs ann&eacute;es, T
          <strong>ouche Pas &agrave; Mon Poste (TPMP) est l&apos;une des &eacute;missions phares du paysage audiovisuel fran&ccedil;ais</strong>.
          Anim&eacute;e par Cyril Hanouna, elle a longtemps &eacute;t&eacute; diffus&eacute;e sur C8 avant d&apos;annoncer son transfert sur{" "}
          <Link className={styles.seoLink} to={formatterHelper.basic(consts.routes.channel, { locale: LOCALE, channelId: 51, channelSlug: "w9" })}>
            W9
          </Link>{" "}
          &agrave; la rentr&eacute;e de septembre.{" "}
          <strong>L&apos;&eacute;mission continue d&apos;attirer chaque soir en streaming des millions de t&eacute;l&eacute;spectateurs</strong>,
          avides de d&eacute;bats anim&eacute;s, d&apos;interviews exclusives et de chroniques d&eacute;jant&eacute;es.
        </p>
        <p className={styles.seoText}>
          Bonne nouvelle pour les fans de TPMP !{" "}
          <strong>Vous pouvez suivre l&apos;&eacute;mission Touche Pas &agrave; Mon Poste en direct et en streaming sur Molotov TV</strong>, la
          plateforme qui vous permet de regarder vos programmes pr&eacute;f&eacute;r&eacute;s en toute simplicit&eacute;. Que vous soyez sur mobile,
          tablette, ordinateur ou TV connect&eacute;e, TPMP est accessible partout et &agrave; tout moment.
        </p>
        <h2 className={styles.seoTitle}>TPMP en streaming gratuit ? C&apos;est sur Molotov.tv</h2>
        <p className={styles.seoText}>
          La nouvelle formule num&eacute;rique de TPMP reste <strong>accessible gratuitement</strong> sur Molotov.tv gr&acirc;ce &agrave; son offre de
          base sans engagement. L&apos;application propose un acc&egrave;s imm&eacute;diat aux contenus sans inscription pr&eacute;alable.
        </p>
        <p className={styles.seoText}>
          Les utilisateurs b&eacute;n&eacute;ficient d&apos;une navigation fluide avec un menu intuitif pour retrouver rapidement leurs
          &eacute;missions favorites. Le <strong>contr&ocirc;le du direct</strong> permet de revenir jusqu&apos;&agrave; 4 heures en arri&egrave;re
          dans le programme, une fonctionnalit&eacute; particuli&egrave;rement appr&eacute;ci&eacute;e des retardataires.
        </p>
        <p className={styles.seoText}>
          La qualit&eacute; HD garantit un confort de visionnage optimal, m&ecirc;me sur une connexion internet mod&eacute;r&eacute;e.
        </p>
        <h3 className={styles.seoSubtitle}>TPMP en stream gratuit sur Youtube ou Dailymotion : pourquoi plut&ocirc;t privil&eacute;gier Molotov</h3>
        <p className={styles.seoText}>
          Contrairement aux plateformes comme YouTube et Dailymotion qui subissent r&eacute;guli&egrave;rement des probl&egrave;mes techniques lors
          des directs, <strong>Molotov garantit une diffusion stable et sans coupure de TPMP</strong>. La plateforme se d&eacute;marque par sa
          fiabilit&eacute; exemplaire et sa qualit&eacute; d&apos;image constante.
        </p>
        <p className={styles.seoText}>
          Les utilisateurs appr&eacute;cient particuli&egrave;rement l&apos;absence de publicit&eacute;s intempestives qui viennent perturber le
          visionnage sur YouTube ou Dailymotion. Un confort visuel renforc&eacute; par{" "}
          <strong>
            une interface &eacute;pur&eacute;e et professionnelle qui vous fera pr&eacute;f&eacute;rer Molotov pour regarder le streaming gratuit de
            Touche pas &agrave; Mon Poste.
          </strong>
        </p>
        <p className={styles.seoText}>
          La fonction exclusive de rattrapage permet de revoir les moments forts manqu&eacute;s, tandis que Molotov est le seul player &agrave;
          proposer l&apos;enregistrement.&nbsp;Des atouts majeurs face aux commentaires parfois toxiques des autres plateformes de streaming.
        </p>
        <h2 className={styles.seoTitle}>Comment regarder TPMP en streaming sur Molotov TV ?</h2>
        <h3 className={styles.seoSubtitle}>Les plateformes compatibles</h3>
        <p className={styles.seoText}>
          Vous pouvez <strong>regarder Touche Pas &agrave; Mon Poste en streaming sur Molotov TV</strong> via plusieurs dispositifs :
        </p>
        <ul className={styles.seoText}>
          <li>
            <strong>Smartphones et tablettes</strong> : disponible sur iOS et Android.
          </li>
          <li>
            <strong>Ordinateurs</strong> : acc&eacute;dez &agrave; Molotov TV via un navigateur web.
          </li>
          <li>
            <strong>Smart TV</strong> : Samsung, LG, Sony, et plus encore.
          </li>
          <li>
            <strong>Appareils connect&eacute;s</strong> : Chromecast, Apple TV, Amazon Fire Stick.
          </li>
          <li>
            <strong>Consoles de jeux</strong> : PlayStation et Xbox.
          </li>
        </ul>
        <h3 className={styles.seoSubtitle}>Les box TV compatibles</h3>
        <p className={styles.seoText}>TPMP est accessible sur plusieurs box TV, directement via Molotov :</p>
        <ul className={styles.seoText}>
          <li>
            <strong>Orange TV</strong>
          </li>
          <li>
            <strong>Bbox de Bouygues Telecom</strong>
          </li>
          <li>
            <strong>Freebox</strong>
          </li>
          <li>
            <strong>SFR Box</strong>
          </li>
          <li>
            <strong>Red by SFR</strong>
          </li>
          <li>
            <strong>Canal+</strong> via myCanal
          </li>
        </ul>
        <h2 className={styles.seoTitle}>Pourquoi regarder TPMP en streaming sur Molotov TV ?</h2>
        <h3 className={styles.seoSubtitle}>Une exp&eacute;rience de visionnage optimale</h3>
        <ul className={styles.seoText}>
          <li>
            <strong>Qualit&eacute; HD</strong> : Profitez de TPMP avec une image nette et fluide.
          </li>
          <li>
            <strong>Sans engagement</strong> : Aucune obligation d&rsquo;abonnement longue dur&eacute;e.
          </li>
          <li>Accessibilit&eacute; sur tous les &eacute;crans : Regardez TPMP o&ugrave; que vous soyez.</li>
        </ul>
        <h3 className={styles.seoSubtitle}>Un acc&egrave;s &agrave; toutes les &eacute;missions en replay</h3>
        <ul className={styles.seoText}>
          <li>
            <strong>Ne manquez aucun &eacute;pisode</strong> : Rattrapez les moments forts en replay.
          </li>
          <li>
            <strong>Regardez &agrave; votre rythme</strong> : Pause, avance rapide, reprise d&rsquo;un programme en cours.
          </li>
        </ul>
        <h3 className={styles.seoSubtitle}>Les exclusivit&eacute;s de Molotov TV</h3>
        <ul className={styles.seoText}>
          <li>
            <strong>Alertes et notifications</strong> : soyez averti avant chaque diffusion.
          </li>
          <li>
            <strong>Fonction d&rsquo;enregistrement</strong> : stockez vos &eacute;missions pr&eacute;f&eacute;r&eacute;es.
          </li>
          <li>
            <strong>Mode picture-in-picture</strong> : regardez TPMP tout en naviguant.
          </li>
        </ul>
        <h2 className={styles.seoTitle}>Quand revient TPMP ?</h2>
        <p className={styles.seoText}>
          <strong>Depuis le 3 mars 2025</strong>, la nouvelle formule de TPMP a pris son envol sur diff&eacute;rentes plateformes num&eacute;riques
          dont Molotov TV qui permet notamment l&apos;enregistrement des programmes. Suite &agrave; la fermeture de la cha&icirc;ne C8,
          l&apos;&eacute;mission poursuit d&eacute;sormais son aventure sur Dailymotion et YouTube, du lundi au jeudi de 18h30 &agrave; 21h15.
        </p>
        <p className={styles.seoText}>
          Une phase transitoire s&apos;amorce avant<strong>&nbsp;le grand basculement vers le Groupe M6 pr&eacute;vu pour septembre 2025</strong>.
          L&apos;&eacute;quipe de Cyril Hanouna conserve son ADN avec des d&eacute;bats anim&eacute;s et des s&eacute;quences divertissantes, tout en
          pr&eacute;parant une formule renouvel&eacute;e pour W9.
        </p>
        <p className={styles.seoText}>
          Les fid&egrave;les retrouvent leur rendez-vous quotidien via la webt&eacute;l&eacute; baptis&eacute;e &quot;Zoubida TV&quot;,
          sp&eacute;cialement cr&eacute;&eacute;e pour l&apos;occasion. Un changement qui marque la fin d&apos;une &eacute;poque sous
          l&apos;&egrave;re Vincent Bollor&eacute;, mais qui ouvre de nouvelles perspectives pour ce talk-show embl&eacute;matique.
        </p>
        <h2 className={styles.seoTitle}>TPMP en streaming : &agrave; quoi s&apos;attendre d&eacute;sormais dans l&apos;&eacute;mission ?</h2>
        <p className={styles.seoText}>
          La nouvelle diffusion de TPMP en streaming ne devrait rien changer au format d&apos;apr&egrave;s Cyril Hanouna. Au contraire !
        </p>
        <h3 className={styles.seoSubtitle}>TPMP ce soir : rien ne change ou presque !</h3>
        <p className={styles.seoText}>
          La premi&egrave;re &eacute;mission diffus&eacute;e ce lundi a rassur&eacute; les fans. Le <strong>nouveau d&eacute;cor</strong>, plus
          moderne et &eacute;pur&eacute;, garde l&apos;esprit convivial caract&eacute;ristique du talk-show. L&apos;&eacute;quipe a conserv&eacute;
          ses s&eacute;quences phares comme le &quot;6 &agrave; 7&quot; et le &quot;TPMP People&quot;.
        </p>
        <p className={styles.seoText}>
          Les t&eacute;l&eacute;spectateurs retrouvent la m&ecirc;me ambiance d&eacute;contract&eacute;e avec un plateau qui accueille
          d&eacute;sormais jusqu&apos;&agrave; 15 chroniqueurs simultan&eacute;ment. Un changement notable : l&apos;interaction avec le public
          s&apos;intensifie gr&acirc;ce &agrave; un dispositif technique permettant d&apos;afficher en temps r&eacute;el les r&eacute;actions des
          internautes.
        </p>
        <p className={styles.seoText}>
          Le <strong>format reste dynamique</strong> avec des d&eacute;bats sur l&apos;actualit&eacute; m&eacute;diatique, entrecoup&eacute;s de
          s&eacute;quences humoristiques et de happenings improvis&eacute;s. Une nouveaut&eacute; appr&eacute;ci&eacute;e : la rubrique &quot;Dans les
          coulisses de Zoubida TV&quot; d&eacute;voile les secrets de fabrication de l&apos;&eacute;mission.
        </p>
        <h3 className={styles.seoSubtitle}>Chroniqueurs de TPMP : les nouveaux et les absents</h3>
        <p className={styles.seoText}>
          Tourn&eacute;e sur le m&ecirc;me plateau que lorsque l&apos;&eacute;mission &eacute;tait diffus&eacute;e sur la TNT, en streaming et en
          replay sur C8, l&apos;&eacute;mission vous propose de <strong>retrouver &agrave; nouveau en streaming les m&ecirc;mes chroniqueurs</strong>{" "}
          &agrave; quelques exceptions pr&egrave;s !
        </p>
        <p className={styles.seoText}>
          Kelly Vedovelli partie en vacances, les internautes qui regarderont TPMP en streaming seront ravi de retrouver Jordan de Luxe, qui
          retrouvera sa place de chroniqueur autour de la table.
        </p>
        <p className={styles.seoText}>
          Cyril Hanouna ayant fortement ouvert la porte au duo &Eacute;lodie Ageron et Sandrine Arcizet, qui animait &quot;Les animaux de la 8&quot;,
          il y a fort &agrave; parier que de nouvelles t&ecirc;tes, anciens animateurs et animatrices de C8, devraient se retrouver autour de la
          table.
        </p>
        <h3 className={styles.seoSubtitle}>Cyril Hanouna et TPMP : pourquoi le streaming gratuit n&apos;est plus sur C8 ?</h3>
        <p className={styles.seoText}>
          <strong>La fermeture de C8 r&eacute;sulte d&apos;une d&eacute;cision de l&apos;Arcom de ne pas renouveler sa fr&eacute;quence TNT</strong>.
          Cette mesure fait suite &agrave; de <strong>multiples sanctions</strong> accumul&eacute;es par la cha&icirc;ne, totalisant plus de 7,6
          millions d&apos;euros d&apos;amendes li&eacute;es aux d&eacute;rapages de l&apos;&eacute;mission.
        </p>
        <p className={styles.seoText}>
          Face &agrave; cette situation, la production a rapidement mis en place une solution alternative. La cr&eacute;ation de Zoubida TV permet
          d&eacute;sormais
          <strong>
            &nbsp;la diffusion quotidienne en streaming du programme sur les plateformes num&eacute;riques, en attendant le transfert vers W9 en
            septembre.
          </strong>
        </p>
        <p className={styles.seoText}>
          Cette transition marque un tournant historique pour le talk-show qui quitte d&eacute;finitivement la TNT apr&egrave;s 13 saisons sur C8. Un
          changement qui refl&egrave;te l&apos;&eacute;volution des modes de consommation t&eacute;l&eacute;visuelle, o&ugrave; le num&eacute;rique
          prend une place pr&eacute;pond&eacute;rante.
        </p>
        <p className={styles.seoText}>
          R&eacute;sultat : vous pouvez d&eacute;sormais retrouver Touche pas &agrave; Mon Poste en streaming HD gratuit via votre plateforme
          pr&eacute;f&eacute;r&eacute;e, Molotov.tv !
        </p>
        <h3 className={styles.seoSubtitle}>Toujours des d&eacute;bats d&rsquo;actualit&eacute;</h3>
        <p className={styles.seoText}>
          Chaque soir, Cyril Hanouna et ses chroniqueurs d&eacute;cryptent en streaming l&apos;actualit&eacute;, avec humour et pertinence. Mais bien
          s&ucirc;r <strong>regarder TPMP en streaming</strong>, c&apos;est l&apos;assurance de nouvelles pol&eacute;miques et de buzz, attirant
          l&apos;attention de tous : m&eacute;dia, public et m&ecirc;me classe politique !
        </p>
        <p className={styles.seoText}>
          Stars du cin&eacute;ma, chanteurs, sportifs : TPMP en streaming va continuer de proposer chaque jour son lot d&apos;invit&eacute;s de
          prestige.
        </p>
        <h2 className={styles.seoTitle}>Molotov TV et TPMP en streaming : le duo gagnant !</h2>
        <p className={styles.seoText}>
          Avec Molotov TV, <strong>Touche Pas &agrave; Mon Poste en streaming devient plus accessible que jamais</strong>. Suivez
          l&apos;&eacute;mission en direct ou en replay, depuis tous vos appareils, et ne manquez plus un seul moment fort de TPMP.
        </p>
        <p className={styles.seoText}>
          Que vous soyez fan des d&eacute;bats anim&eacute;s ou des happenings de Cyril Hanouna, Molotov TV est la plateforme id&eacute;ale pour
          profiter de votre &eacute;mission pr&eacute;f&eacute;r&eacute;e o&ugrave; que vous soyez.
        </p>
        <h3 className={styles.seoSubtitle}>Molotov et TPMP en streaming gratuit : pari r&eacute;ussi</h3>
        <p className={styles.seoText}>
          Le partenariat entre Molotov et TPMP s&apos;annonce particuli&egrave;rement prometteur. Les premiers chiffres d&apos;audience
          d&eacute;montrent un v&eacute;ritable engouement : <strong>plus de 800 000 spectateurs</strong> se connectent quotidiennement via la
          plateforme pour suivre les d&eacute;bats anim&eacute;s de l&apos;&eacute;mission.
        </p>
        <p className={styles.seoText}>
          La qualit&eacute; de visionnage exceptionnelle propos&eacute;e par Molotov s&eacute;duit les fans. Le chat int&eacute;gr&eacute; permet aux
          t&eacute;l&eacute;spectateurs d&apos;interagir en temps r&eacute;el avec la communaut&eacute;, cr&eacute;ant une exp&eacute;rience
          interactive unique.
        </p>
        <p className={styles.seoText}>
          Les <strong>fonctionnalit&eacute;s exclusives</strong> comme le contr&ocirc;le du direct et le start-over transforment radicalement
          l&apos;exp&eacute;rience de visionnage. Les utilisateurs appr&eacute;cient notamment la possibilit&eacute; de revenir jusqu&apos;&agrave; 4
          heures en arri&egrave;re dans le programme sans attendre le replay.
        </p>
      </div>
    )
  }

  return false
}
